import { jsx as _jsx } from "react/jsx-runtime";
import { inputBaseClasses } from '@mui/material/InputBase';
import * as React from 'react';
import { FlexBox } from '../../box';
import { IconSearch } from '../../icon';
import { TextField } from '../../textfield';
const NAVIGATION_KEYS = ['ArrowDown', 'ArrowUp', 'Enter', 'Escape'];
export const FacilitySearch = (props) => {
    const inputRef = React.useRef(null);
    React.useEffect(() => {
        const timeout = setTimeout(() => {
            inputRef.current?.focus();
        }, 200);
        return () => clearTimeout(timeout);
    }, []);
    const onKeyDown = (event) => {
        const autocompleteInputEl = props.autocompleteInputRef?.current;
        if (NAVIGATION_KEYS.includes(event.key) && autocompleteInputEl) {
            event.preventDefault();
            autocompleteInputEl.dispatchEvent(new KeyboardEvent(event.type, {
                key: event.key,
                code: event.code,
                bubbles: true,
                cancelable: true,
                shiftKey: event.shiftKey,
                ctrlKey: event.ctrlKey,
                altKey: event.altKey,
                metaKey: event.metaKey
            }));
        }
    };
    return (_jsx(FlexBox, { padding: [1, 1.5], children: _jsx(TextField, { inputRef: inputRef, clearable: true, value: props.search, variant: "standard", placeholder: props.placeholder, onKeyDown: onKeyDown, slotProps: {
                input: {
                    startAdornment: _jsx(IconSearch, {}),
                    disableUnderline: true
                }
            }, sx: {
                [`.${inputBaseClasses.root}`]: { gap: 1 },
                [`.${inputBaseClasses.input}`]: {
                    boxSizing: 'border-box',
                    p: 0
                }
            }, onChange: props.onSearch }) }));
};
